// The rail is the app's only global chrome, so its two widths are the offset
// every page's content area is positioned against.
export const RAIL_COLLAPSED_WIDTH = 72
export const RAIL_EXPANDED_WIDTH = 256
